import {
  Button,
  Col,
  Edit,
  Row,
  SaveButton,
  useForm,
} from "@pankod/refine-antd";
import {
  IResourceComponentsProps,
  useNavigation,
  useNotification,
} from "@pankod/refine-core";
import { PartnerForm } from "components/forms";
import { IPartner } from "interfaces/partner";
import { FC } from "react";
import { normalizePartnerPhone } from "utils/formaters";
import { extractApiErrorMessage } from "utils/utils";

export const PartnerEdit: FC<IResourceComponentsProps> = () => {
  const { goBack } = useNavigation();
  const { open } = useNotification();
  const { formProps, saveButtonProps, queryResult } = useForm<IPartner>({
    errorNotification: false,
    onMutationError: (error) => {
      const message = extractApiErrorMessage(error);
      open?.({
        type: "error",
        description: "Erro ao criar parceiro!",
        message,
      });
    },
  });

  const transformEditPartnerValues = (values: IPartner): IPartner => ({
    ...values,
    partner_phone: values.partner_phone
      ? normalizePartnerPhone(values.partner_phone)
      : values.partner_phone,
  });

  return (
    <Edit
      headerButtons={[]}
      title="Editar Parceiro"
      saveButtonProps={saveButtonProps}
      footerButtons={() => (
        <Row gutter={16}>
          <Col>
            <Button onClick={() => goBack()} style={{ minWidth: "92px" }}>
              Cancelar
            </Button>
          </Col>

          <Col>
            <SaveButton
              {...saveButtonProps}
              icon={null}
              style={{ minWidth: "92px" }}
            >
              Salvar
            </SaveButton>
          </Col>
        </Row>
      )}
    >
      <PartnerForm
        formProps={formProps}
        queryResult={queryResult}
        transformValuesOnSubmit={transformEditPartnerValues}
      />
    </Edit>
  );
};
